module.exports = __webpack_public_path__ + "img/蒙版组-24.4e6aca8c.jpg";